module.exports = __webpack_public_path__ + "img/local-12.308d5f08.jpg";